export default {
  pt: {
    'gestoes.historico.titulo': 'Histórico do colaborador',
    'gestoes.historico.carregando': 'Consultando as gestões anteriores do colaborador.',
    'gestoes.historico.erro': 'Não foi possível consultar o histórico: {{erro}}',
    'gestoes.historico.possui': 'Este colaborador já possui, para a ocorrência {{ocorrencia}}: {{lista}}.',
    'gestoes.historico.nenhuma': 'Para a ocorrência {{ocorrencia}}, não foram encontradas gestões anteriores.',
    'gestoes.historico.dica': 'Gestões pendentes e aplicadas do colaborador para o mesmo tipo de ocorrência. As canceladas não contam. O aviso não impede a escolha do tipo.',
    'gestoes.historico.verbal_one': '{{count}} Orientação verbal',
    'gestoes.historico.verbal_other': '{{count}} Orientações verbais',
    'gestoes.historico.escrita_one': '{{count}} Orientação escrita',
    'gestoes.historico.escrita_other': '{{count}} Orientações escritas',
    'gestoes.historico.advertencia_one': '{{count}} Advertência',
    'gestoes.historico.advertencia_other': '{{count}} Advertências',
    'gestoes.historico.suspensao_one': '{{count}} Suspensão',
    'gestoes.historico.suspensao_other': '{{count}} Suspensões',
    'gestoes.aba.ocorrencias': 'Relatório de Ocorrências',
    'gestoes.aba.pendente': 'Gestões Pendentes',
    'gestoes.aba.aplicada': 'Gestões Aplicadas',
    'gestoes.tipo': 'Tipo da gestão',
    'gestoes.tipo.verbal': 'Orientação Verbal',
    'gestoes.tipo.escrita': 'Orientação Escrita',
    'gestoes.tipo.advertencia': 'Advertência',
    'gestoes.tipo.suspensao': 'Suspensão',
    'gestoes.status': 'Status',
    'gestoes.status.pendente': 'Pendente',
    'gestoes.status.tratado': 'Tratado',
    'gestoes.status.aplicada': 'Aplicada',
    'gestoes.status.cancelada': 'Cancelada',
    'gestoes.codigo': 'Código da gestão',
    'gestoes.justificativa': 'Justificativa',
    'gestoes.todos': 'Todos',
    'gestoes.gerar': 'Gerar Gestão',
    'gestoes.aplicar': 'Marcar como aplicada',
    'gestoes.cancelar': 'Cancelar gestão',
    'gestoes.gerarOk': 'Gestão gerada. Ela está em Gestões Pendentes.',
    'gestoes.aplicadaOk': 'Aplicação registrada. A gestão passou para Gestões Aplicadas.',
    'gestoes.canceladaOk': 'Gestão cancelada. As ocorrências voltaram para o Relatório de Ocorrências.',
    'gestoes.erro.tipo': 'Selecione o tipo da gestão.',
    'gestoes.erro.aplicacao': 'Informe a data, o responsável e a forma da aplicação.',
    'gestoes.erro.aplicacaoVerbal': 'Informe a data e o responsável pela aplicação.',
    'gestoes.erro.cancelamento': 'Informe a data e a justificativa do cancelamento.',
    'gestoes.erro.data': 'A data não pode ser futura.',
    'gestoes.erro.antesDaGeracao': 'A data da aplicação não pode ser anterior à geração da gestão.',
    'gestoes.dataAplicacao': 'Data da aplicação',
    'gestoes.responsavelAplicacao': 'Responsável pela aplicação',
    'gestoes.formaAplicacao': 'Forma de aplicação',
    'gestoes.formaAssinatura': 'Forma de assinatura',
    'gestoes.forma.colaborador': 'Assinado pelo colaborador',
    'gestoes.forma.testemunha': 'Assinado por testemunha',
    'gestoes.forma.naoExigida': 'Não exigida',
    'gestoes.forma.naoInformada': 'Não informada',
    'gestoes.verbalSemAssinatura': 'Orientação verbal não exige assinatura do colaborador nem de testemunha. Informe a data e o responsável pela aplicação.',
    'gestoes.dataCancelamento': 'Data do cancelamento',
    'gestoes.canceladoPor': 'Cancelado por',
    'gestoes.cancelamentoHint': 'As ocorrências voltarão a Pendente no Relatório de Ocorrências e poderão compor uma nova gestão. Esta gestão permanecerá no histórico.',
    'gestoes.geracao': 'Geração',
    'gestoes.geradoPor': 'Gerado por',
    'gestoes.geradoEm': 'Gerado em',
    'gestoes.aplicacao': 'Aplicação',
    'gestoes.cancelamento': 'Cancelamento',
    'gestoes.historico': 'Histórico',
    'gestoes.acao.gerar': 'Gestão gerada',
    'gestoes.acao.aplicar': 'Aplicação registrada',
    'gestoes.acao.cancelar': 'Gestão cancelada e ocorrências devolvidas',
    'gestoes.acao.numero_protheus': 'Número no Protheus alterado',
    'gestoes.anterior': 'Status anterior',
    'gestoes.novo': 'Novo status',
    'gestoes.ocorrenciasEvento': '{{n}} ocorrências vinculadas',
    'gestoes.vazio.pendente': 'Nenhuma gestão pendente com os filtros atuais.',
    'gestoes.vazio.aplicada': 'Nenhuma gestão aplicada com os filtros atuais.',
    'gestoes.hint.pendente': 'Gestões geradas que ainda não foram aplicadas. O período e as datas filtram pela data da ocorrência, na folha do dia 16 ao dia 15; sem data, aparecem todas. Registrada a aplicação, a gestão passa para Gestões Aplicadas.',
    'gestoes.hint.aplicada': 'Gestões com a aplicação registrada. O período e as datas filtram pela data da ocorrência, na folha do dia 16 ao dia 15; sem data, aparecem todas.',
    'gestoes.documentos': 'Controle operacional. O HUB não emite documento oficial: o texto de cada gestão é copiado para o Protheus, e o PDF assinado é anexado na gestão aplicada.',
    'gestoes.detalhar': 'Ver gestão',
    'gestoes.fechar': 'Fechar',
    'gestoes.matricula': 'Matrícula',
    'gestoes.funcao': 'Função',
    'gestoes.historicoAnterior': 'Gestões anteriores',
    'gestoes.selecionar': 'Selecionar ocorrência de {{dia}}',
    'gestoes.detalhe.quantidade': '{{n}} lançamentos na origem',
    'gestoes.numeroProtheus': 'Número no Protheus',
    'gestoes.naoInformado': 'Não informado',
    'gestoes.informarNumero': 'Informar número',
    'gestoes.alterarNumero': 'Alterar número',
    'gestoes.salvar': 'Salvar',
    'gestoes.descartar': 'Descartar',
    'gestoes.numeroSalvo': 'Número no Protheus registrado.',
    'gestoes.numeroAnterior': 'Número anterior',
    'gestoes.numeroNovo': 'Novo número',
    'gestoes.umDia': '1 dia',
    'gestoes.nDias': '{{n}} dias',
    'gestoes.diasPendente': 'Tempo pendente',
    'gestoes.tempoAplicacao': 'Tempo para aplicação',
    'gestoes.filtro.ocorrenciaDe': 'Ocorrência de',
    'gestoes.filtro.ocorrenciaAte': 'Ocorrência até',
    'gestoes.filtro.limparData': 'Limpar data',
    'gestoes.ranking.titulo': 'Pendentes há mais tempo',
    'gestoes.ranking.vazio': 'Nenhuma gestão pendente.',
    'gestoes.ranking.geral': 'Ranking geral',
    'gestoes.ranking.base': 'Ranking por Base',
    'gestoes.ranking.semBase': 'Sem base',
    'gestoes.contagem_one': '{{count}} gestão',
    'gestoes.contagem_other': '{{count}} gestões',
    'gestoes.texto.gerar': 'Gerar Texto',
    'gestoes.texto.coluna': 'Texto',
    'gestoes.texto.titulo': 'Texto para o Protheus',
    'gestoes.texto.campo': 'Texto',
    'gestoes.texto.hint': 'Revise e edite o texto antes de copiar e colar no Protheus. Gerar, editar ou copiar o texto não altera o status da gestão.',
    'gestoes.texto.copiar': 'Copiar Texto',
    'gestoes.texto.copiado': 'Texto copiado.',
    'gestoes.texto.copiaFalhou': 'Não foi possível copiar o texto.',
    'gestoes.anexo.titulo': 'Documento assinado',
    'gestoes.anexo.coluna': 'Documento',
    'gestoes.anexo.com': 'Documento anexado',
    'gestoes.anexo.sem': 'Sem documento',
    'gestoes.anexo.hint': 'A gestão assinada, digitalizada em PDF. Só arquivo .pdf, até 10 MB.',
    'gestoes.anexo.semAplicacao': 'O documento é anexado depois de registrar a aplicação.',
    'gestoes.anexo.anexar': 'Anexar PDF',
    'gestoes.anexo.substituir': 'Substituir PDF',
    'gestoes.anexo.abrir': 'Abrir',
    'gestoes.anexo.baixar': 'Baixar',
    'gestoes.anexo.enviadoPor': 'Enviado por',
    'gestoes.anexo.enviadoEm': 'Enviado em',
    'gestoes.anexo.tamanho': 'Tamanho',
    'gestoes.anexo.ok': 'Documento anexado à gestão.',
    'gestoes.anexo.substituidoOk': 'Documento substituído.',
    'gestoes.anexo.substituiu': 'Substituiu o documento anterior',
    'gestoes.anexo.abrirFalhou': 'Não foi possível abrir o documento.',
    'gestoes.anexo.erro.extensao': 'Selecione um arquivo .pdf.',
    'gestoes.anexo.erro.tamanho': 'O arquivo não pode passar de 10 MB.',
    'gestoes.anexo.erro.vazio': 'O arquivo está vazio.',
    'gestoes.acao.anexo': 'Documento anexado',
    'gestoes.anexo.tituloVerbal': 'Documento',
    'gestoes.anexo.hintVerbal': 'O registro da orientação, como o print da conversa no WhatsApp. Arquivo .pdf, .png ou .jpg, até 10 MB.',
    'gestoes.anexo.anexarVerbal': 'Anexar documento',
    'gestoes.anexo.substituirVerbal': 'Substituir documento',
    'gestoes.anexo.erro.extensaoVerbal': 'Selecione um arquivo .pdf, .png ou .jpg.',
    'gestoes.col.ocorrencia': 'Data da ocorrência',
    'gestoes.col.periodo': 'Período da folha',
    'gestoes.ocorrenciaIntervalo': '{{de}} a {{ate}}',
    'gestoes.periodosDiferentes': 'As ocorrências marcadas são de períodos de folha diferentes, {{periodos}}. Gere uma gestão para cada período.',
    'gestoes.excel.dica': 'Uma linha por ocorrência das gestões da aba, com os filtros atuais: período, data, filial e matrícula, nome, infração, tipo, situação e os números da gestão no HUB e no Protheus.',
    'gestoes.excel.vazio': 'Nenhuma gestão para baixar com os filtros atuais.',
  },
  en: {
    'gestoes.historico.titulo': 'Employee history',
    'gestoes.historico.carregando': 'Checking the employee\'s previous measures.',
    'gestoes.historico.erro': 'Could not check the history: {{erro}}',
    'gestoes.historico.possui': 'For the occurrence {{ocorrencia}}, this employee already has: {{lista}}.',
    'gestoes.historico.nenhuma': 'For the occurrence {{ocorrencia}}, no previous measures were found.',
    'gestoes.historico.dica': 'Pending and applied measures of the employee for the same occurrence type. Canceled ones do not count. The notice does not block any measure type.',
    'gestoes.historico.verbal_one': '{{count}} Verbal guidance',
    'gestoes.historico.verbal_other': '{{count}} Verbal guidances',
    'gestoes.historico.escrita_one': '{{count}} Written guidance',
    'gestoes.historico.escrita_other': '{{count}} Written guidances',
    'gestoes.historico.advertencia_one': '{{count}} Warning',
    'gestoes.historico.advertencia_other': '{{count}} Warnings',
    'gestoes.historico.suspensao_one': '{{count}} Suspension',
    'gestoes.historico.suspensao_other': '{{count}} Suspensions',
    'gestoes.aba.ocorrencias': 'Occurrence report',
    'gestoes.aba.pendente': 'Pending measures',
    'gestoes.aba.aplicada': 'Applied measures',
    'gestoes.tipo': 'Measure type', 'gestoes.tipo.verbal': 'Verbal guidance',
    'gestoes.tipo.escrita': 'Written guidance', 'gestoes.tipo.advertencia': 'Warning',
    'gestoes.tipo.suspensao': 'Suspension', 'gestoes.status': 'Status',
    'gestoes.status.pendente': 'Pending', 'gestoes.status.tratado': 'Handled',
    'gestoes.status.aplicada': 'Applied', 'gestoes.status.cancelada': 'Canceled',
    'gestoes.codigo': 'Measure code', 'gestoes.justificativa': 'Reason',
    'gestoes.todos': 'All',
    'gestoes.gerar': 'Create measure', 'gestoes.aplicar': 'Mark as applied', 'gestoes.cancelar': 'Cancel measure',
    'gestoes.gerarOk': 'Measure created. It is now in Pending measures.',
    'gestoes.aplicadaOk': 'Application recorded. The measure moved to Applied measures.',
    'gestoes.canceladaOk': 'Measure canceled. The occurrences are back in the Occurrence report.',
    'gestoes.erro.tipo': 'Select the measure type.', 'gestoes.erro.aplicacao': 'Enter the application date, responsible person and method.',
    'gestoes.erro.aplicacaoVerbal': 'Enter the application date and the person responsible.',
    'gestoes.erro.cancelamento': 'Enter the cancellation date and reason.', 'gestoes.erro.data': 'The date cannot be in the future.',
    'gestoes.erro.antesDaGeracao': 'The application date cannot be earlier than the measure creation.',
    'gestoes.dataAplicacao': 'Application date', 'gestoes.responsavelAplicacao': 'Person responsible for application',
    'gestoes.formaAplicacao': 'Application method', 'gestoes.forma.colaborador': 'Signed by the employee',
    'gestoes.formaAssinatura': 'Signature',
    'gestoes.forma.testemunha': 'Signed by a witness',
    'gestoes.forma.naoExigida': 'Not required',
    'gestoes.forma.naoInformada': 'Not provided',
    'gestoes.verbalSemAssinatura': 'Verbal guidance requires no signature from the employee or a witness. Enter the application date and the person responsible.',
    'gestoes.dataCancelamento': 'Cancellation date', 'gestoes.canceladoPor': 'Canceled by',
    'gestoes.cancelamentoHint': 'The occurrences will become Pending in the Occurrence report and can be included in a new measure. This measure will remain in the history.',
    'gestoes.geracao': 'Creation', 'gestoes.geradoPor': 'Created by', 'gestoes.geradoEm': 'Created at',
    'gestoes.aplicacao': 'Application', 'gestoes.cancelamento': 'Cancellation', 'gestoes.historico': 'History',
    'gestoes.acao.gerar': 'Measure created', 'gestoes.acao.aplicar': 'Application recorded',
    'gestoes.acao.cancelar': 'Measure canceled and occurrences released', 'gestoes.acao.numero_protheus': 'Protheus number changed',
    'gestoes.anterior': 'Previous status', 'gestoes.novo': 'New status', 'gestoes.ocorrenciasEvento': '{{n}} linked occurrences',
    'gestoes.vazio.pendente': 'No pending measures for the current filters.',
    'gestoes.vazio.aplicada': 'No applied measures for the current filters.',
    'gestoes.hint.pendente': 'Measures created and not yet applied. The period and dates filter by occurrence date, in the payroll from the 16th to the 15th; without a date, all are shown. Once the application is recorded, the measure moves to Applied measures.',
    'gestoes.hint.aplicada': 'Measures with a recorded application. The period and dates filter by occurrence date, in the payroll from the 16th to the 15th; without a date, all are shown.',
    'gestoes.documentos': 'Operational control. The HUB does not issue official documents: the text of each measure is copied into Protheus, and the signed PDF is attached to the applied measure.',
    'gestoes.detalhar': 'View measure', 'gestoes.fechar': 'Close', 'gestoes.matricula': 'Employee ID',
    'gestoes.funcao': 'Role', 'gestoes.historicoAnterior': 'Previous measures',
    'gestoes.selecionar': 'Select occurrence on {{dia}}',
    'gestoes.detalhe.quantidade': '{{n}} entries at source',
    'gestoes.numeroProtheus': 'Protheus number', 'gestoes.naoInformado': 'Not provided',
    'gestoes.informarNumero': 'Add number', 'gestoes.alterarNumero': 'Change number',
    'gestoes.salvar': 'Save', 'gestoes.descartar': 'Discard', 'gestoes.numeroSalvo': 'Protheus number recorded.',
    'gestoes.numeroAnterior': 'Previous number', 'gestoes.numeroNovo': 'New number',
    'gestoes.umDia': '1 day', 'gestoes.nDias': '{{n}} days', 'gestoes.diasPendente': 'Time pending',
    'gestoes.tempoAplicacao': 'Time to application',
    'gestoes.filtro.ocorrenciaDe': 'Occurrence from', 'gestoes.filtro.ocorrenciaAte': 'Occurrence until', 'gestoes.filtro.limparData': 'Clear date',
    'gestoes.ranking.titulo': 'Pending the longest', 'gestoes.ranking.vazio': 'No pending measures.',
    'gestoes.ranking.geral': 'Overall ranking',
    'gestoes.ranking.base': 'Ranking by base',
    'gestoes.ranking.semBase': 'No base',
    'gestoes.contagem_one': '{{count}} measure',
    'gestoes.contagem_other': '{{count}} measures',
    'gestoes.texto.gerar': 'Generate text', 'gestoes.texto.coluna': 'Text', 'gestoes.texto.titulo': 'Text for Protheus',
    'gestoes.texto.campo': 'Text',
    'gestoes.texto.hint': 'Review and edit the text before copying it into Protheus. Generating, editing or copying the text does not change the measure status.',
    'gestoes.texto.copiar': 'Copy text', 'gestoes.texto.copiado': 'Text copied.', 'gestoes.texto.copiaFalhou': 'Could not copy the text.',
    'gestoes.anexo.titulo': 'Signed document', 'gestoes.anexo.coluna': 'Document',
    'gestoes.anexo.com': 'Document attached', 'gestoes.anexo.sem': 'No document',
    'gestoes.anexo.hint': 'The signed measure, scanned as PDF. Only .pdf files, up to 10 MB.',
    'gestoes.anexo.semAplicacao': 'The document is attached after the application is recorded.',
    'gestoes.anexo.anexar': 'Attach PDF', 'gestoes.anexo.substituir': 'Replace PDF',
    'gestoes.anexo.abrir': 'Open', 'gestoes.anexo.baixar': 'Download',
    'gestoes.anexo.enviadoPor': 'Uploaded by', 'gestoes.anexo.enviadoEm': 'Uploaded at', 'gestoes.anexo.tamanho': 'Size',
    'gestoes.anexo.ok': 'Document attached to the measure.', 'gestoes.anexo.substituidoOk': 'Document replaced.',
    'gestoes.anexo.substituiu': 'Replaced the previous document', 'gestoes.anexo.abrirFalhou': 'Could not open the document.',
    'gestoes.anexo.erro.extensao': 'Select a .pdf file.', 'gestoes.anexo.erro.tamanho': 'The file cannot exceed 10 MB.',
    'gestoes.anexo.erro.vazio': 'The file is empty.',
    'gestoes.acao.anexo': 'Document attached',
    'gestoes.anexo.tituloVerbal': 'Document',
    'gestoes.anexo.hintVerbal': 'The record of the guidance, such as a screenshot of the WhatsApp conversation. A .pdf, .png or .jpg file, up to 10 MB.',
    'gestoes.anexo.anexarVerbal': 'Attach document', 'gestoes.anexo.substituirVerbal': 'Replace document',
    'gestoes.anexo.erro.extensaoVerbal': 'Select a .pdf, .png or .jpg file.',
    'gestoes.col.ocorrencia': 'Occurrence date', 'gestoes.col.periodo': 'Payroll period',
    'gestoes.ocorrenciaIntervalo': '{{de}} to {{ate}}',
    'gestoes.periodosDiferentes': 'The selected occurrences belong to different payroll periods, {{periodos}}. Create one measure for each period.',
    'gestoes.excel.dica': 'One row per occurrence of the measures in this tab, with the current filters: period, date, branch and employee ID, name, infraction, type, status and the measure numbers in HUB and Protheus.',
    'gestoes.excel.vazio': 'No measures to download with the current filters.',
  },
  es: {
    'gestoes.historico.titulo': 'Historial del colaborador',
    'gestoes.historico.carregando': 'Consultando las gestiones anteriores del colaborador.',
    'gestoes.historico.erro': 'No fue posible consultar el historial: {{erro}}',
    'gestoes.historico.possui': 'Para la ocurrencia {{ocorrencia}}, este colaborador ya tiene: {{lista}}.',
    'gestoes.historico.nenhuma': 'Para la ocurrencia {{ocorrencia}}, no se encontraron gestiones anteriores.',
    'gestoes.historico.dica': 'Gestiones pendientes y aplicadas del colaborador para el mismo tipo de ocurrencia. Las canceladas no cuentan. El aviso no impide elegir el tipo.',
    'gestoes.historico.verbal_one': '{{count}} Orientación verbal',
    'gestoes.historico.verbal_other': '{{count}} Orientaciones verbales',
    'gestoes.historico.escrita_one': '{{count}} Orientación escrita',
    'gestoes.historico.escrita_other': '{{count}} Orientaciones escritas',
    'gestoes.historico.advertencia_one': '{{count}} Amonestación',
    'gestoes.historico.advertencia_other': '{{count}} Amonestaciones',
    'gestoes.historico.suspensao_one': '{{count}} Suspensión',
    'gestoes.historico.suspensao_other': '{{count}} Suspensiones',
    'gestoes.aba.ocorrencias': 'Informe de ocurrencias',
    'gestoes.aba.pendente': 'Gestiones pendientes',
    'gestoes.aba.aplicada': 'Gestiones aplicadas',
    'gestoes.tipo': 'Tipo de gestión', 'gestoes.tipo.verbal': 'Orientación verbal',
    'gestoes.tipo.escrita': 'Orientación escrita', 'gestoes.tipo.advertencia': 'Amonestación',
    'gestoes.tipo.suspensao': 'Suspensión', 'gestoes.status': 'Estado',
    'gestoes.status.pendente': 'Pendiente', 'gestoes.status.tratado': 'Tratado',
    'gestoes.status.aplicada': 'Aplicada', 'gestoes.status.cancelada': 'Cancelada',
    'gestoes.codigo': 'Código de gestión', 'gestoes.justificativa': 'Justificación',
    'gestoes.todos': 'Todos',
    'gestoes.gerar': 'Generar gestión', 'gestoes.aplicar': 'Marcar como aplicada', 'gestoes.cancelar': 'Cancelar gestión',
    'gestoes.gerarOk': 'Gestión generada. Está en Gestiones pendientes.',
    'gestoes.aplicadaOk': 'Aplicación registrada. La gestión pasó a Gestiones aplicadas.',
    'gestoes.canceladaOk': 'Gestión cancelada. Las ocurrencias volvieron al Informe de ocurrencias.',
    'gestoes.erro.tipo': 'Seleccione el tipo de gestión.', 'gestoes.erro.aplicacao': 'Informe la fecha, el responsable y la forma de la aplicación.',
    'gestoes.erro.aplicacaoVerbal': 'Informe la fecha y el responsable de la aplicación.',
    'gestoes.erro.cancelamento': 'Informe la fecha y la justificación de la cancelación.', 'gestoes.erro.data': 'La fecha no puede ser futura.',
    'gestoes.erro.antesDaGeracao': 'La fecha de aplicación no puede ser anterior a la generación de la gestión.',
    'gestoes.dataAplicacao': 'Fecha de aplicación', 'gestoes.responsavelAplicacao': 'Responsable de la aplicación',
    'gestoes.formaAplicacao': 'Forma de aplicación', 'gestoes.forma.colaborador': 'Firmado por el colaborador',
    'gestoes.formaAssinatura': 'Firma',
    'gestoes.forma.testemunha': 'Firmado por testigo',
    'gestoes.forma.naoExigida': 'No exigida',
    'gestoes.forma.naoInformada': 'No informada',
    'gestoes.verbalSemAssinatura': 'La orientación verbal no exige firma del colaborador ni de testigo. Informe la fecha y el responsable de la aplicación.',
    'gestoes.dataCancelamento': 'Fecha de cancelación', 'gestoes.canceladoPor': 'Cancelado por',
    'gestoes.cancelamentoHint': 'Las ocurrencias volverán a Pendiente en el Informe de ocurrencias y podrán integrar una nueva gestión. Esta gestión permanecerá en el historial.',
    'gestoes.geracao': 'Generación', 'gestoes.geradoPor': 'Generado por', 'gestoes.geradoEm': 'Generado el',
    'gestoes.aplicacao': 'Aplicación', 'gestoes.cancelamento': 'Cancelación', 'gestoes.historico': 'Historial',
    'gestoes.acao.gerar': 'Gestión generada', 'gestoes.acao.aplicar': 'Aplicación registrada',
    'gestoes.acao.cancelar': 'Gestión cancelada y ocurrencias devueltas', 'gestoes.acao.numero_protheus': 'Número en Protheus modificado',
    'gestoes.anterior': 'Estado anterior', 'gestoes.novo': 'Nuevo estado', 'gestoes.ocorrenciasEvento': '{{n}} ocurrencias vinculadas',
    'gestoes.vazio.pendente': 'Ninguna gestión pendiente con los filtros actuales.',
    'gestoes.vazio.aplicada': 'Ninguna gestión aplicada con los filtros actuales.',
    'gestoes.hint.pendente': 'Gestiones generadas que aún no se aplicaron. El período y las fechas filtran por la fecha de la ocurrencia, en la nómina del día 16 al día 15; sin fecha, aparecen todas. Registrada la aplicación, la gestión pasa a Gestiones aplicadas.',
    'gestoes.hint.aplicada': 'Gestiones con la aplicación registrada. El período y las fechas filtran por la fecha de la ocurrencia, en la nómina del día 16 al día 15; sin fecha, aparecen todas.',
    'gestoes.documentos': 'Control operativo. El HUB no emite documentos oficiales: el texto de cada gestión se copia en Protheus, y el PDF firmado se adjunta en la gestión aplicada.',
    'gestoes.detalhar': 'Ver gestión', 'gestoes.fechar': 'Cerrar', 'gestoes.matricula': 'Matrícula',
    'gestoes.funcao': 'Función', 'gestoes.historicoAnterior': 'Gestiones anteriores',
    'gestoes.selecionar': 'Seleccionar ocurrencia de {{dia}}',
    'gestoes.detalhe.quantidade': '{{n}} registros en origen',
    'gestoes.numeroProtheus': 'Número en Protheus', 'gestoes.naoInformado': 'No informado',
    'gestoes.informarNumero': 'Informar número', 'gestoes.alterarNumero': 'Cambiar número',
    'gestoes.salvar': 'Guardar', 'gestoes.descartar': 'Descartar', 'gestoes.numeroSalvo': 'Número en Protheus registrado.',
    'gestoes.numeroAnterior': 'Número anterior', 'gestoes.numeroNovo': 'Nuevo número',
    'gestoes.umDia': '1 día', 'gestoes.nDias': '{{n}} días', 'gestoes.diasPendente': 'Tiempo pendiente',
    'gestoes.tempoAplicacao': 'Tiempo hasta la aplicación',
    'gestoes.filtro.ocorrenciaDe': 'Ocurrencia desde', 'gestoes.filtro.ocorrenciaAte': 'Ocurrencia hasta', 'gestoes.filtro.limparData': 'Limpiar fecha',
    'gestoes.ranking.titulo': 'Pendientes hace más tiempo', 'gestoes.ranking.vazio': 'Ninguna gestión pendiente.',
    'gestoes.ranking.geral': 'Ranking general',
    'gestoes.ranking.base': 'Ranking por base',
    'gestoes.ranking.semBase': 'Sin base',
    'gestoes.contagem_one': '{{count}} gestión',
    'gestoes.contagem_other': '{{count}} gestiones',
    'gestoes.texto.gerar': 'Generar texto', 'gestoes.texto.coluna': 'Texto', 'gestoes.texto.titulo': 'Texto para Protheus',
    'gestoes.texto.campo': 'Texto',
    'gestoes.texto.hint': 'Revise y edite el texto antes de copiarlo y pegarlo en Protheus. Generar, editar o copiar el texto no cambia el estado de la gestión.',
    'gestoes.texto.copiar': 'Copiar texto', 'gestoes.texto.copiado': 'Texto copiado.', 'gestoes.texto.copiaFalhou': 'No fue posible copiar el texto.',
    'gestoes.anexo.titulo': 'Documento firmado', 'gestoes.anexo.coluna': 'Documento',
    'gestoes.anexo.com': 'Documento adjunto', 'gestoes.anexo.sem': 'Sin documento',
    'gestoes.anexo.hint': 'La gestión firmada, digitalizada en PDF. Solo archivo .pdf, hasta 10 MB.',
    'gestoes.anexo.semAplicacao': 'El documento se adjunta después de registrar la aplicación.',
    'gestoes.anexo.anexar': 'Adjuntar PDF', 'gestoes.anexo.substituir': 'Reemplazar PDF',
    'gestoes.anexo.abrir': 'Abrir', 'gestoes.anexo.baixar': 'Descargar',
    'gestoes.anexo.enviadoPor': 'Enviado por', 'gestoes.anexo.enviadoEm': 'Enviado el', 'gestoes.anexo.tamanho': 'Tamaño',
    'gestoes.anexo.ok': 'Documento adjuntado a la gestión.', 'gestoes.anexo.substituidoOk': 'Documento reemplazado.',
    'gestoes.anexo.substituiu': 'Reemplazó el documento anterior', 'gestoes.anexo.abrirFalhou': 'No fue posible abrir el documento.',
    'gestoes.anexo.erro.extensao': 'Seleccione un archivo .pdf.', 'gestoes.anexo.erro.tamanho': 'El archivo no puede superar 10 MB.',
    'gestoes.anexo.erro.vazio': 'El archivo está vacío.',
    'gestoes.acao.anexo': 'Documento adjuntado',
    'gestoes.anexo.tituloVerbal': 'Documento',
    'gestoes.anexo.hintVerbal': 'El registro de la orientación, como la captura de la conversación de WhatsApp. Archivo .pdf, .png o .jpg, hasta 10 MB.',
    'gestoes.anexo.anexarVerbal': 'Adjuntar documento', 'gestoes.anexo.substituirVerbal': 'Reemplazar documento',
    'gestoes.anexo.erro.extensaoVerbal': 'Seleccione un archivo .pdf, .png o .jpg.',
    'gestoes.col.ocorrencia': 'Fecha de la ocurrencia', 'gestoes.col.periodo': 'Período de nómina',
    'gestoes.ocorrenciaIntervalo': '{{de}} a {{ate}}',
    'gestoes.periodosDiferentes': 'Las ocurrencias marcadas son de períodos de nómina diferentes, {{periodos}}. Genere una gestión para cada período.',
    'gestoes.excel.dica': 'Una línea por ocurrencia de las gestiones de la pestaña, con los filtros actuales: período, fecha, filial y matrícula, nombre, infracción, tipo, situación y los números de la gestión en el HUB y en el Protheus.',
    'gestoes.excel.vazio': 'Ninguna gestión para descargar con los filtros actuales.',
  },
}
